import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/announcement'
import pathMap from 'src/paths/pathMap'

class AnnouncementRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ANNOUNCEMENT_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ANNOUNCEMENT_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ANNOUNCEMENT_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ANNOUNCEMENT_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default AnnouncementRoute
